var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2079_12704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 1.33487C6.54998 1.34097 6.27981 1.36702 6.06136 1.47833C5.81047 1.60616 5.6065 1.81014 5.47867 2.06102C5.36736 2.27947 5.34131 2.54964 5.33521 2.99967M13 1.33487C13.45 1.34097 13.7202 1.36702 13.9387 1.47833C14.1895 1.60616 14.3935 1.81014 14.5214 2.06102C14.6327 2.27947 14.6587 2.54964 14.6648 2.99967M14.6648 8.99967C14.6587 9.44971 14.6327 9.71987 14.5214 9.93833C14.3935 10.1892 14.1895 10.3932 13.9387 10.521C13.7202 10.6323 13.45 10.6584 13 10.6645M14.6667 5.333V6.66634M9.33338 1.33301H10.6666M3.46668 14.6663H8.53334C9.28008 14.6663 9.65345 14.6663 9.93866 14.521C10.1895 14.3932 10.3935 14.1892 10.5214 13.9383C10.6667 13.6531 10.6667 13.2797 10.6667 12.533V7.46634C10.6667 6.7196 10.6667 6.34624 10.5214 6.06102C10.3935 5.81014 10.1895 5.60616 9.93866 5.47833C9.65345 5.33301 9.28008 5.33301 8.53334 5.33301H3.46668C2.71994 5.33301 2.34657 5.33301 2.06136 5.47833C1.81047 5.60616 1.6065 5.81014 1.47867 6.06102C1.33334 6.34624 1.33334 6.7196 1.33334 7.46634V12.533C1.33334 13.2797 1.33334 13.6531 1.47867 13.9383C1.6065 14.1892 1.81047 14.3932 2.06136 14.521C2.34657 14.6663 2.71994 14.6663 3.46668 14.6663Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2079_12704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9184fe9f93aeb875b8be84ddb08934e9.svg";
export { ForwardRef as ReactComponent };